import OadpEntityFilter from './oadp-entity-filter';
export default OadpEntityFilter;
